module.exports = __webpack_public_path__ + "assets/85988ad45763eec59c2a05c2ae7d3e08.mp3";